import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import classNames from 'classnames';
import TooltipOnHover from '../../../components/TooltipOnHover';

var IconCell = function IconCell(_ref) {
  var Icon = _ref.icon,
      tooltip = _ref.tooltip,
      isActive = _ref.isActive,
      children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return true;
  } : _ref$onClick;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  return React.createElement("div", {
    className: "flexbox flexbox-grow",
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, React.createElement("div", {
    style: {
      display: 'inline-flex',
      flexWrap: 'wrap',
      minHeight: 31
    },
    className: "flexbox-grow flexbox-align-start"
  }, children), React.createElement(TooltipOnHover, {
    placement: "top",
    tooltipContent: tooltip,
    withArrow: false
  }, React.createElement("span", {
    className: classNames('flexbox pointer transition flexbox-centered radius-normal', 'shade-20 shade-10-on-hover background-shade-50-on-hover', {
      hidden: !hovered && !isActive
    }),
    onClick: onClick,
    style: {
      minWidth: 24,
      height: 24,
      alignSelf: 'center'
    }
  }, React.createElement(Icon, null))));
};

export default React.memo(IconCell);